import { NgModule } from '@angular/core';
import { SafePipe } from './safe.pipe';
import { UsingCodePipe } from './using-code.pipe';

@NgModule({
    declarations: [SafePipe, UsingCodePipe],
    exports: [SafePipe, UsingCodePipe],
})
export class PipesModule {}
